<div class="loader-container">
  <svg
    class="infinity-loader"
    width="220"
    height="120"
    viewBox="0 0 220 120"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <!-- Brand gradient -->
      <linearGradient id="infinityGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stop-color="#fdb50a" />
        <stop offset="45%" stop-color="#e40072" />
        <stop offset="100%" stop-color="#6a1fd6" />
      </linearGradient>

      <!-- Mask for weaving -->
      <mask id="weave-mask">
        <!-- Visible -->
        <rect width="100%" height="100%" fill="white" />

        <!-- Cut sections (under passes) -->
        <circle cx="110" cy="60" r="16" fill="black" />
        <circle cx="70" cy="60" r="14" fill="black" />
        <circle cx="150" cy="60" r="14" fill="black" />
      </mask>
    </defs>

    <!-- Base infinity ribbon -->
    <path
      id="infinity-path"
      d="
        M30,60
        C30,15 95,15 110,60
        C125,105 190,105 190,60
        C190,15 125,15 110,60
        C95,105 30,105 30,60
      "
      fill="none"
      stroke="url(#infinityGradient)"
      stroke-width="14"
      stroke-linecap="round"
      stroke-dasharray="120 360"
    />

    <!-- Overpass -->
    <path
      d="
        M30,60
        C30,15 95,15 110,60
        C125,105 190,105 190,60
        C190,15 125,15 110,60
        C95,105 30,105 30,60
      "
      fill="none"
      stroke="url(#infinityGradient)"
      stroke-width="14"
      stroke-linecap="round"
      mask="url(#weave-mask)"
    />
  </svg>
</div>
